/** @format */

import { Col, Form, Row } from 'antd';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { setGlobal } from 'reactn';
import { Enviroment } from '../../_config/constants/enviroment-v2.constant';
import CustomButton from '../../v2-components/Antd/Button';
import CustomFormItem from '../../v2-components/Antd/FormItem';
import CustomInput from '../../v2-components/Antd/Input';
import Images from '../../v2-components/Images';
import { CustomNotification } from '../../v2-components/Notification';
import Stock from './components/Stock';
import { adaptProductResponse } from './handle/product-response-adapter.handle';
import { ReactComponent as IconSearch } from './icons/search.svg';
import { Service } from './service';
import useSearchStore from './store/useSearchStore';
import './style.scss';

export default function SearchComponent({ pharmacy = null, disabled}) {
	let location = useLocation();
	const [form] = Form.useForm();
	const [isResult, setResult] = useState([]);
	const [isFocus, setFocus] = useState(false);
	const addProduct = useSearchStore((state) => state.addProduct);

	const handleSearchList = (item, data) => {
		setFocus(true);
		if (item?.target?.value?.length >= 2) {
			new Service().searchProducts(item.target.value, pharmacy).then((response) => {
				console.log('response',response?.results)
				const results = response.results?.map(adaptProductResponse);
				setResult(results);
			});
		}
	};

	const handleNotificationSearch = () => {
		<CustomNotification type="error" message="Búsqueda de Productos" description="Debe ingresar un nombre de producto para buscar." />;

		return;
	};

	const handleSearchResult = async (item) => {
		if (item.inputSearch) {
			if (item.inputSearch.trim() === '') {
				handleNotificationSearch();
			} else {
				window.location.href = window.location.origin + `/results/${item.inputSearch}`;
			}
		} else {
			handleNotificationSearch();
		}
	};

	const handleCleanList = (item) => {
		setGlobal({ searchDrawer: false });
		form.setFieldsValue({
			inputSearch: '',
		});
		setResult([]);
	};

	const handleInputSearchClass = () => {
		if (navigator.userAgent.toLowerCase().indexOf('iphone') !== -1) {
			return 'ph-search-header-input-iphone';
		} else {
			return 'ph-search-header-input-windows';
		}
	};

	useEffect(() => {
		form.setFieldsValue({
			inputSearch: '',
		});
		setResult([]);
	}, [location.pathname, form]);

	return (
		<>
			<div className="ph-search-global-container">
				<div
					className="ph-search-header-main-container"
					tabIndex="0"
					onFocus={() => setFocus(true)}
					onBlur={() =>
						setTimeout(() => {
							setFocus(false);
						}, 250)
					}
				>
					<div className="ph-search-header-container">
						<Form onFinish={handleSearchResult} name="main_search" autoComplete="off" form={form}>
							<CustomFormItem className="ph-search-header-form-item" name="inputSearch">
								<CustomInput
									disabled={disabled}
									type="text"
									onClick={() => setFocus(true)}
									onChange={(item) => handleSearchList(item, 'pharol')}
									placeholder="Búsqueda en productos..."
									className={`${handleInputSearchClass()} ph-search-header`}
								/>
							</CustomFormItem>
							<CustomFormItem className="ph-search-header-button-container">
								<CustomButton className="ph-search-header-button" htmlType="submit">
									<IconSearch className={'ph-search-mobile-icons-theme-search'} />
								</CustomButton>
							</CustomFormItem>
						</Form>
					</div>
					{isResult?.length > 0 && (
						<ul className={`ph-search-header-list-main-container`} style={isFocus ? { display: 'block' } : { display: 'none' }}>
							{isResult?.map((item, index) => (
								<li className="ph-search-header-list" onClick={() => handleCleanList(item)} key={index}>
									<Row
										style={{ cursor: 'pointer' }}
										onClick={(e) => {
                      // 2. ¡Detén el burbujeo!
                      // Esto evita que se llame a handleCleanList() en el 'li'
                      e.stopPropagation();
                      
                      // 3. Llama a tu acción de Zustand
                      addProduct({
                        sku: item.id_pharol,
                        editable_name: item.editable_name,
                        laboratory: item.laboratory,
                        image: item.image,
                        price: item.price,
                        promotion_price: item.promotion_price,
												quantity: 1,
                      });
                      
                      // 4. (Opcional pero recomendado) Cierra la lista manualmente
                      handleCleanList(item);
                    }
										}
									>
										<Col span={2} className="ph-search-header-images-search-content">
											<Images
												classContent={'ph-search-header-list-image-container'}
												classImage={'ph-search-header-list-image'}
												src={item.image}
												alt={item.editable_name}
												title={item.editable_name}
											/>
										</Col>
										<Col span={22} className="ph-search-header-titles-search-content">
											<h3 className="ph-search-header-titles-search-h3">
												{item.editable_name}
												{item.cenabast === 'Cenabast' && (
													<>
														<span>{' (cenabast)'}</span>
													</>
												)}
											</h3>
											{item.available > 0 ? (
												<p className="ph-search-header-titles-search-p">
													<span>Laboratorio {item.laboratory}</span>
													{Enviroment.COUNTRY !== 'AR' && `, consultar en `}
													<span
														className="ph-search-header-titles-search-contents-p-span"
														style={{ display: Enviroment.COUNTRY === 'AR' && 'none' }}
													>
														{item.available} Farmacia(s)
													</span>
												</p>
											) : (
												<p className="ph-search-header-titles-search-p">
													<span> Laboratorio {item.laboratory}</span>
												</p>
											)}
											{item.stock && <Stock stock={item.stock} />}
										</Col>
									</Row>
								</li>
							))}
						</ul>
					)}
				</div>
			</div>
		</>
	);
}
